// @ts-nocheck

import TagManager from "./TagManager";

export default TagManager;
